import React from 'react'

import {
  arrayOf, bool, func, node, number, shape, string,
} from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

import NumberOfItems from './NumberOfItems'
import PaginationCard from './PaginationCard'
import PerPage, { DEFAULT_PER_PAGE_OPTIONS } from './PerPage'

// Every label falls back to the subcomponents' English defaults, so existing consumers render
// unchanged; localized pages pass `labels` (and `ariaLabel` for the navigation landmark).
// `pageControls` swaps the button-based page controls for a consumer's own (e.g. crawlable anchors)
// while keeping the item counter and per-page selector around them.
function Pagination({
  currentPage,
  totalPages,
  totalCount,
  perPage,
  onPageChange: handlePageChange,
  onPerPageChange: handlePerPageChange,
  alwaysShow = false,
  perPageOptions = DEFAULT_PER_PAGE_OPTIONS,
  labels = EMPTY_OBJECT,
  ariaLabel = '',
  pageControls = null,
}) {
  if (!alwaysShow && totalPages <= 1) {
    return null
  }

  return (
    <div
      className="shared-pagination"
      role={ariaLabel ? 'navigation' : undefined}
      aria-label={ariaLabel || undefined}
    >
      <NumberOfItems
        totalCount={totalCount}
        perPage={perPage}
        currentPage={currentPage}
        label={labels.showing}
      />
      {pageControls || (
        <PaginationCard
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          labels={labels}
        />
      )}
      <PerPage
        perPage={perPage}
        onPerPageChange={handlePerPageChange}
        options={perPageOptions}
        label={labels.perPage}
      />
    </div>
  )
}

Pagination.propTypes = {
  currentPage: number.isRequired,
  totalPages: number.isRequired,
  totalCount: number.isRequired,
  perPage: number.isRequired,
  onPageChange: func.isRequired,
  onPerPageChange: func.isRequired,
  alwaysShow: bool,
  perPageOptions: arrayOf(number),
  labels: shape({
    showing: func,
    perPage: string,
    firstPage: string,
    previousPage: string,
    nextPage: string,
    lastPage: string,
    pageInput: string,
  }),
  ariaLabel: string,
  pageControls: node,
}

export default Pagination
